import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import React from 'react';

import PayoutInvoices from './components/Invoices';

const NewPayOut = (props: {
  setOpen: (open: boolean) => void;
  open: boolean;
  setSuccessOpen: (success: string) => void;
  setFailureOpen: (failure: string) => void;
  setUp: () => Promise<void>;
}) => {
  const { setOpen, open, setSuccessOpen, setFailureOpen, setUp } = props;

  return (
    <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
      <DialogTitle>Registro de pago a proveedores</DialogTitle>
      <DialogContent>
        <PayoutInvoices
          setSuccessOpen={setSuccessOpen}
          setFailureOpen={setFailureOpen}
          setUp={setUp}
          setOpen={setOpen}
        />
      </DialogContent>
    </Dialog>
  );
};

export default NewPayOut;
